import { navigate } from '@healthhub/react-ui';
import { Modal, Typography } from 'antd';

import { Button } from '@shared/components';
import { useLayoutViewContext } from '@shared/context';

interface Props {
  actualUrl?: string;
  description?: string;
  title?: string;
  url: string;
}

const RedirectionModal = ({ actualUrl, description, title, url }: Props) => {
  const { isPortalView } = useLayoutViewContext();

  const onClose = () => {
    Modal.destroyAll();
  };

  const onProceed = () => {
    if (isPortalView) {
      window.open(actualUrl ?? url, '_blank');
    } else {
      navigate(actualUrl ?? url);
    }

    onClose();
  };

  return (
    <div className="flex flex-col items-center">
      <Typography.Text className="mb-2 text-base font-bold">{title || 'Redirection Notice'}</Typography.Text>
      <Typography.Text className="text-center text-sm">
        {description || 'You will be redirected to an external website'}
      </Typography.Text>

      <Button block className="my-4" onClick={onProceed}>
        Proceed
      </Button>
      <Button block onClick={onClose} variant="secondary">
        Close
      </Button>
    </div>
  );
};

export default RedirectionModal;
